<template>
  <div class="tab-item-cls">
    <div class="title">
      <!-- <span class="tab-img industry-tag"></span>
      <span class="item-title">Industry</span> -->
      <p class="pde" :title="detail">{{detail}}</p>
    </div>
    <el-row class="row-top">
      <el-col :span="12">
        <barLine :xData="xData1" :serData="serData1" :chartHeight="chartHeight"></barLine>
      </el-col>
      <el-col :span="12">
        <barLine :xData="xData2" :serData="serData2" :chartHeight="chartHeight"></barLine>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import barLine from "./barLine";
import color from "./color";
import { getIndustryData } from "common/js/http/v2Api";
export default {
  props: {
    chartHeight: {
      type: Number
    }
  },

  components: {
    barLine
  },

  data() {
    return {
      xData1: [],
      serData1: [],
      xData2: [],
      serData2: [],
      titleList:[],
      detail:`It mainly presents data of agriculture, steel, wine industries. In terms of the steel, you can find steel output, supply, production, sales and trade. In terms of the agriculture data, you can find data of the agricultural products such as sugar, soybean oil, soybean meal, soybean, etc. Data includes inventory, domestic production, supply, consumption, consumption, etc. Meanwhile, you can also find data on tea, wine, poultry meat. `
    };
  },

  created() {
    console.log("industry create");
    this.getIndustryData();
  },

  mounted() {},

  methods: {
    async getIndustryData() {
      this.titleList = [];
      this.xData1 = [];
      this.serData1 = [];
      this.xData2 = [];
      this.serData2 = [];

      const { result } = await getIndustryData();
      this.titleList = Object.keys(result);
      if (this.titleList[0]) {
        const converResult = this.convertData(
          result[this.titleList[0]][0],
          this.titleList[0]
        );
        this.xData1 = converResult.xData;
        this.serData1 = converResult.serData;
      }
      if (this.titleList[1]) {
        const converResult = this.convertData(
          result[this.titleList[1]][0],
          this.titleList[1]
        );
        this.xData2 = converResult.xData;
        this.serData2 = converResult.serData;
      }
    },

    convertData(item, name) {
      const xData = [];
      const unit = item.unit;
      const i = Math.round(Math.random()*10);
      const data = Object.assign(this.getCommonConfig(i), {
        name,
        data: [],
        unit
      });

      item.data.forEach(i => {
        data.data.push(i.value);
        xData.push(this.$moment(i.moditime).format("YYYY-MM-DD"));
      });
      return {
        xData,
        serData: [data]
      };
    },

    getCommonConfig(index) {
      return {
        name: "",
        type: "bar",
        // stack: "dta",
        data: [],
        unit: "",
        barMinHeight: 5,
        smooth: true,
        itemStyle: {
          normal: {
            color: color[index % 10], //改变折线点的颜色
            lineStyle: {
              color: color[index % 10] //改变折线颜色
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.company-title {
  font-size: 12px;
  color: #000000;
  margin-top: 30px;
  font-weight: 600;
}
.row-top {
  margin-top: 49px;
}
</style>